angular.module('GlobalHelpersModule').filter "threadParticipantNameFromProfileGuid", ($rootScope, AuthService) ->
  (profileGuid, providersByProfileGuid) ->
    if profileGuid.toLowerCase() == AuthService.getPhrUserGuid().toLowerCase()
      'You'
    else
      provider = providersByProfileGuid[profileGuid.toLowerCase()] or
        firstName: $rootScope.DS.getCurrentPractice().practice_name
        lastName: 'Staff'
      provider.first_name + ' ' + provider.last_name
